import React, { useContext, useState, useCallback } from 'react';
import clsx from 'clsx';

import { ChipGroup } from 'components';

import { CreateTeamContext, actionTypes } from '../createTeamContext';

export const UserChips = () => {
  const {
    createTeamState: { selectedUserList },
    dispatch,
  } = useContext(CreateTeamContext);

  const [showOpened, setShowOpened] = useState(false);

  const handleShowOpened = useCallback(() => {
    setShowOpened((e) => !e);
  });

  const NoUsers = () => {
    return (
      <div
        className={clsx(
          'Caption-Emphasis',
          'm-create-team__user-chips__no-users',
        )}
        data-testid="PlatformAdminUI-TeamsLink-UserChips-Body"
      >
        Nobody is assigned to this team right now. Add someone below.
      </div>
    );
  };

  const handleRemove = (email) => {
    dispatch({
      type: actionTypes.SET_USER_CHECKED_STATE,
      email,
    });
  };

  const chipList = selectedUserList.map((user) => {
    return {
      key: user.email,
      label: `${user.firstName} ${user.lastName}`,
      onDelete: handleRemove,
    };
  });

  const ShowChips = () => {
    if (selectedUserList.length === 0) {
      return <NoUsers />;
    }

    return (
      <ChipGroup
        chipList={chipList}
        open={showOpened}
        showClick={handleShowOpened}
        className="editTeam"
      />
    );
  };

  return (
    <div
      className="m-create-team__user-chips"
      data-testid="PlatformAdminUI-TeamsLink-UserChips"
    >
      <div
        className={clsx('Caption-Emphasis', 'm-create-team__user-chips__title')}
        data-testid="PlatformAdminUI-TeamsLink-UserChips-Title"
      >
        Users currently assigned to this team
      </div>
      <ShowChips />
    </div>
  );
};
